import { t } from "../../utils/i18n";
import React from "react";
import AutoComplete from "../AutoComplete";

const WalletTransfer = ({
  selectedTransferType,
  submitting,
  transferTypes,
  destinationWallets,
  validationErrors,
  recipient,
  lookedUpRecipient,
  recipients,
  selectedDestinationWallet,
  handleChange,
  handleRecipientChange
}) => (
  <div>
    <div className="form-group row required recipient">
      <label className="form-label">{t("transfers_send.common.to")}</label>
      <AutoComplete
        updateRecipient={handleRecipientChange}
        placeholder={t("transfers_send.common.recipient_placeholder")}
        className={`form-control ${
          validationErrors?.recipientError ? "is-invalid" : ""
        }`}
        disabled={submitting == true ? true : false}
        suggestions={recipients}
        lookedUpRecipient={lookedUpRecipient}
        userInput={recipient}
      />
      {validationErrors?.recipientError && (
        <span className="error text-danger">
          <br />
          {validationErrors.recipientError}
        </span>
      )}

      <small id="amountHelpBlock" className="form-text text-muted">
        {t("transfers_send.common.recipient_help")}
      </small>
    </div>
  </div>
);

export default WalletTransfer;
